import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.606 15.2c.308.235.454.63.371 1.013a.993.993 0 01-.753.764.979.979 0 01-.999-.377l-3.943-4a1.01 1.01 0 010-1.4l3.943-4a.975.975 0 011.289.093c.347.352.386.909.092 1.307l-3.234 3.3 3.253 3.3h-.02z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
